import { FollowCard, withFollow } from '@eventbrite/follow-organizer-ebui';
import React from 'react';
import { useIsInViewPort, useSetDisabledNav } from '../../SimpleCarousel/hooks';

interface OrganizerCardProps {
    organizerId: string;
    slideNumber: number;
    childrenLength: number;
    setDisabledNav: any;
}

const EnhancedFollowCard = withFollow(FollowCard);

export const OrganizerCard: React.FunctionComponent<OrganizerCardProps> = (
    props,
) => {
    const { organizerId, slideNumber, childrenLength, setDisabledNav } = props;
    const slideRef = React.useRef<HTMLLIElement>(null);
    const isLastSlide = slideNumber === childrenLength - 1;
    const isFirstSlide = slideNumber === 0;
    const { isVisible } = useIsInViewPort({
        ref: slideRef,
        trackVisibility: isLastSlide || isFirstSlide,
    });
    useSetDisabledNav({
        isLastSlide,
        isFirstSlide,
        isVisible,
        setDisabledNav,
    });

    return (
        <li
            ref={slideRef}
            key={organizerId}
            className="category-browse__organizer-follow--list-item"
        >
            <EnhancedFollowCard
                gaCategory="category-page"
                style="grid"
                size="standard"
                organizerId={organizerId}
                shouldHideDefaultDataPoint={true}
            />
        </li>
    );
};
